export default {
    'add-currency': 'Añadir moneda',
    'edit-currency': 'Editar moneda',
    'currency-name': 'Nombre de moneda',
    'currency-symbol': 'Símbolo de moneda',
    'equivalent-price-with-system-currency': 'Tipos de cambio de la moneda principal',
    save: 'Guardar',
    cancel: 'Cancelar',
    'currency-equivalent-rate-update-record-for': 'Historia del tipo de cambio de',
    'ok': 'De acuerdo',
    'update-currency-price': 'Actualizar tipo de cambio',
    'update-currency-date': 'Fecha de actualizar',

    'history-headers': {
        'equivalent-price-with-system-currency': 'Tipos de cambio de la moneda principal',
        'update-date': 'Fecha de actualización',
    },

    headers: {
        'currency-symbol': 'Símbolo de moneda',
        'currency-name': 'Nombre de la moneda',
        'equivalent-price': 'Tipos de cambio',
        'actions': 'Acciones',
    },
    'delete-currency': 'eliminar moneda',
    'are-you-sure-you-want-to-delete-the-currency': '¿Estás segura de que quieres eliminar la moneda?'
}